import { render } from "./commentsContainer.vue?vue&type=template&id=2b1cd2dd&scoped=true&ts=true"
import script from "./commentsContainer.vue?vue&type=script&lang=ts"
export * from "./commentsContainer.vue?vue&type=script&lang=ts"

import "./commentsContainer.vue?vue&type=style&index=0&id=2b1cd2dd&scoped=true&lang=css"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1cd2dd"]])

export default __exports__